module.exports = __webpack_public_path__ + "static/media/Scale_green.717d03f1.png";